import React from 'react'

import { FormName } from 'redux-form'

export type FormNameProps = {
  form: string
}

const withFormName = (Component) => (props) => {
  return (
    <FormName>{({ form }) => <Component {...props} form={form} />}</FormName>
  )
}

export default withFormName
